export const parseUrl = (search: string): UrlParams => {
    if (
        window.location.origin === "http://localhost:3000"
        || window.location.origin === "https://localhost:3000"
        || window.location.origin === "http://192.168.0.150:3000"
        || window.location.origin === "https://192.168.0.150:3000"
    ) {
        return {
            // sessiontoken: JSON.stringify({
            //     playerId: "5ffc589a-76b5-4237-8773-1023b77301b7-web",
            //     terminalId: 0,
            // }),
            // sessiontoken: JSON.stringify({
            //     playerId: "3ec7038d-d2e3-493d-a9ea-9f57d7f0c4dd-web",
            //     terminalId: 0,
            // }),
            sessiontoken: JSON.stringify({
                playerId: "f8c49337-0cf1-4eae-8e22-d6fb5d15c75d-web",
                terminalId: 0,
            }),
            // sessiontoken: "GUEST",
            clubid: "1",
            lang: "ru",
            srv: "dev",
            debug: "false",
            cl: "true",
            sport: "true"
        }
    }

    if (search[0] !== "?") {
        search = "?" + search.slice(1);
    }
    const params = new URLSearchParams(search);

    return {
        sessiontoken: params.get("sessiontoken"),
        clubid: params.get("clubid"),
        lang: params.get("lang"),
        srv: params.get("srv"),
        debug: params.get("debug"),
        cl: params.get("cl"),
        sport: params.get("sport")
    }
};

type UrlParams = {
    sessiontoken: string | null;
    clubid: string | null;
    lang: string | null;
    srv: string | null;
    debug: string | null;
    cl: string | null;
    sport: string | null;
};
